import { Component, OnInit, ViewChild  } from "@angular/core";
import * as moment from 'moment';
import * as toastr from "toastr";

import { State, City, Districts } from "@shared/models";
import { Utilservice } from '@core/services/util.service';

import { Visit } from "../../models/visit.interface";
import { VisitasService } from "../../services/visitas.service";
import { ModalOutrasInfoComponent } from '../../components/modal-outras-info/modal.outras.info'

@Component({
  selector: "app-historico",
  templateUrl: "./historico.component.html",
  styleUrls: ["./historico.component.css"]
})
export class HistoricoComponent implements OnInit {
  @ViewChild(ModalOutrasInfoComponent, {static:false})
  private ModalOutrasInfoComponent: ModalOutrasInfoComponent

  lsStates: State[];
  selectedState: number;

  isRequesting: boolean = false;
  isFormFiltersRequesting: boolean = false;
  isRequestingGrid: boolean = false;
  isRequestingStates: boolean = false;
  isRequestingCities: boolean = false;

  lsCities: City[];
  selectedCity: number;

  lsDistricts: Districts[];
  selectedDistrict: string;
  selectedVendedor: string;
  selectedStatus: string;

  id = 1;

  myFilter = {
    estado: "",
    cidade: "",
    razaoSocial: "",
    bairro: "",
    logradouro: "",
    dataInicial: "",
    dataFinal: "",
    vendedor: "",
    status: "",
    cnpj: "",
    IdFormaVisita: ""
  };

  lsVisits: Visit[] = [];
  lsVededores: any[] = [];
  lsStatusVisita: any[] = [];
  lsFormasVisitas: any[] = [];

  cnpjPattern = /^([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})$/i;

  userLogado

  minDataFinal;
  maxDataFinal;

  constructor(
    private visitService: VisitasService
  ) {}

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.getStates();
    this.getVendedores();
    this.getStatus();
    this.getFormasVisitas();

    //se for perfil vendedor
    this.userLogado.perfil == 1 ? this.selectedVendedor = this.userLogado.id : '';
  }

  compareDateCurrentWeek(data){
    let startOfWeek = moment().startOf('week');
    let endOfWeek = moment().endOf('week');
    let dataPrev = moment(data, 'DD/MM/YYYY');

    if(dataPrev.isSameOrAfter(startOfWeek) && dataPrev.isSameOrBefore(endOfWeek)) {
      //console.log("semana corrente");
      return true;
    }else{
      return false;
    }
  }

  getStates() {
    this.isRequestingStates = true;
    this.visitService
      .getStates(this.userLogado.idSetor)
      .subscribe(
        data => (this.lsStates = data),
        error => console.log(error),
        () => this.isRequestingStates = false
      );
  }

  getVendedores() {
    this.visitService
      .getVendedores()
      .subscribe(
        data => {
          let filtered = data.filter(e=>e.id != 200); //Tirando VAGO
          this.lsVededores = filtered;
        },
        error => console.log(error)
      );
  }

  getStatus() {
    this.visitService
      .getStatusVisita()
      .subscribe(
        data => (this.lsStatusVisita = data),
        error => console.log(error)
      );
  }

  filterVendedor(vendedor) {
    this.myFilter.vendedor = this.selectedVendedor.toString();
  }

  filterStatus(status) {
    this.myFilter.status = this.selectedStatus.toString();
  }

  filterCities(filterVal: any) {

    this.clearCitiesDistricts();

    if (filterVal === "undefined")
      return;

    this.myFilter.estado = this.selectedState.toString();
    this.isFormFiltersRequesting = true;
    this.isRequestingCities = true;
    this.visitService.getCities(this.selectedState, this.userLogado.idSetor).subscribe(
      data => {
        this.lsCities = data;
        this.lsDistricts = [];
        this.isFormFiltersRequesting = false;
      },
      error => console.log(error),
      () => this.isRequestingCities = false
    );
  }

  filterDistricts(filterVal: any) {
    this.isFormFiltersRequesting = true;
    this.myFilter.cidade = this.selectedCity.toString();
    this.visitService.getDistricts(this.selectedCity, this.userLogado.idSetor).subscribe(
      data => {
        this.isFormFiltersRequesting = false;
        this.lsDistricts = data;
      },
      error => console.log(error),
      () => console.log("Get Districts")
    );
  }

  clearCitiesDistricts() {
    this.lsCities = [];
    this.selectedCity = void 0;
    this.lsDistricts = [];
    this.selectedDistrict = void 0;
  }

  clearForm() {
    this.selectedState = void 0;
    this.myFilter = {
      estado: "",
      cidade: "",
      razaoSocial: "",
      bairro: "",
      logradouro: "",
      dataInicial: "",
      dataFinal: "",
      vendedor: "",
      status: "",
      cnpj: "",
      IdFormaVisita: ""
    };
    this.selectedVendedor = "";
    this.selectedStatus = "";
    this.clearCitiesDistricts();
    this.lsVisits = [];
    this.isRequesting = false;
    this.isFormFiltersRequesting = false;
  }

  searchItems() {
    if(this.myFilter.dataInicial=="" || this.myFilter.dataInicial == undefined || this.myFilter.dataFinal=="" || this.myFilter.dataFinal == undefined){
      this.actionsForError("Informe o período");
    } else {

      let dt_inicial = moment(this.myFilter.dataInicial);
      let dt_final = moment(this.myFilter.dataFinal);
      if (dt_final.isBefore(dt_inicial)){
        this.actionsForError("A data final precisa ser após a inicial");
      } else {
        let NewFilter = {
          estado: this.myFilter.estado,
          cidade: this.myFilter.cidade,
          razaoSocial: this.myFilter.razaoSocial,
          bairro: this.myFilter.bairro,
          logradouro: this.myFilter.logradouro,
          dataInicial: this.myFilter.dataInicial,
          dataFinal: this.myFilter.dataFinal,
          vendedor: this.userLogado.perfil == 1 ? this.userLogado.id : this.selectedVendedor != "" || this.selectedVendedor != null ? this.selectedVendedor : '',
          status: this.myFilter.status,
          cnpj: this.myFilter.cnpj,
          IdFormaVisita: 1
          // IdFormaVisita: this.myFilter.IdFormaVisita
        };

        this.myFilter.estado == "" ? delete NewFilter.estado : "";
        this.myFilter.cidade == "" ? delete NewFilter.cidade : "";
        this.myFilter.status == "" ? delete NewFilter.status : "";
        // this.myFilter.IdFormaVisita == "" || this.myFilter.IdFormaVisita == "Todos" ? delete NewFilter.IdFormaVisita : "";

        this.isRequestingGrid = true;

        this.visitService
          .filterVisitasPorHistorico(NewFilter)
          .subscribe(resp => {
            this.lsVisits = resp
            this.lsVisits.forEach(e=>e.cnpj = e.cnpj.toString());
            this.isRequestingGrid = false;
          }, error => {
            this.isRequestingGrid = false;
            console.log(error)
          });
      }
    }

  }

  private actionsForSuccess(message: string){
    toastr.success(message);
  }

  private actionsForError(message: string){
      toastr.error(message);
  }

  formatDate(date){
    return Utilservice.formatDate(date);
  }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  setModalInformations(item){
    this.ModalOutrasInfoComponent.setInformations(
      item.cnpj,
      item.razaoSocial,
      item.idCliente
    )
  }

  escolhaDataInicial(){
    let max = moment(this.myFilter.dataInicial).add(60, 'days').calendar();
    this.maxDataFinal = moment(max).format("YYYY-MM-DD");
    this.minDataFinal = this.myFilter.dataInicial;
    this.myFilter.dataFinal = "";
  }

  getFormasVisitas() {
    this.visitService.getFormasVisitasAtivas().subscribe(
      resp => {
        this.lsFormasVisitas = resp;
      },
      error => console.log(error)
    )
  }

}
